const BASE = '$account'

export const CURRENT = `${BASE}/current`
export const LOGIN = `${BASE}/login`
export const EUMLOGIN = `${BASE}/eumLogin`
export const USER = `${BASE}/user`
export const LOGINEX = `${BASE}/loginex`
export const LOGINHINT = `${BASE}/loginHint`
export const LOGOUT = `${BASE}/logout`
export const LOGINASSERTION = `${BASE}/loginUserAssertion`
export const MS_ACCESSTOKEN = `${BASE}/ms/accesstoken`
export const MS_ACCESSTOKEN_FORCE = `${BASE}/ms/accesstoken/force`